<template>
    <div class="main">
     <tutorial-search v-on:searchData="searchFromChild"></tutorial-search>
      <div :class="['tutorial-bg',{'search-bg-active':isActive}]" >
        <tutorialList :url="seagate"></tutorialList>
        <tutorialList :url="wd"></tutorialList>
        <tutorialList :url="hitachi" ></tutorialList>
        <tutorialList :url="toshiba"></tutorialList>
        <tutorialList :url="other"></tutorialList>
      </div>
    </div>
</template>

<script>
import tutorialList from './tutorialList/tutorialList'
import tutorialSearch from './tutorialList/tutorialSearch'
  export default {
    name: "tutorial",
    data() {
      return {
        seagate:'seagate',
        wd:'wd',
        hitachi:'hitachi',
        toshiba:'toshiba',
        other:'other',
        search: '',
        searchData:[],
        isActive:false
      }
    },
    components:{tutorialList, tutorialSearch},
    created: function () {

    },
    methods: {
      // 获取子组件（搜索组件）传递的搜索值
      searchFromChild(data){
        this.search=data
        if(this.search){  //判断搜索框是否有内容
          this.isActive=true;
        }else {
          this.isActive=false;
        }
      }
    },

  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
    min-height: calc(100% - 486px);
  }
  .search-bg {display: flex; justify-content: space-between;margin: 20px 5px;
    /*position: relative; */
  }
  .search-input {margin-right: 10px;}
  .search-result {
    /*position: absolute;*/
    width: 100%;
    max-height: 300px;
    overflow: scroll;
    background: #000;
    /*top: 50px;*/
    border: #dedede 1px solid;
    box-shadow: #c5c5c5 0 0 8px;
    display: none;
    transition: all ease 0.3s;
  }
  .search-bg-active {
    display: none;
    transition: all ease 0.3s;}

  .search-result ul {padding: 20px 20px;}
  .search-result ul li {font-size: 14px; line-height: 32px; color:#cfcfcf;}
  .search-result ul li:hover {cursor: pointer; color: #fff;}
  .search-input .el-input__inner:focus {border-color: #00af42;}

  /*.tutorial-bg { display: flex; flex-wrap: wrap; }*/

    /*点击排行*/
  .click-ranking {
    width: 340px;
    box-sizing: border-box;
    border: #e5e5e5 1px solid;
  }

  .ranking-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    margin: 10px 10px;
    border-bottom: #e5e5e5 1px solid;
    padding-bottom: 8px;
  }

  .ranking-title span {
    color: #e60000;
  }

  .ranking-img {
    width: 100%;
    height: 160px;
  }

  .ranking-img-bg {
    position: relative;
    height: 160px;
  }

  .ranking-img-bg:hover {
    cursor: pointer;
  }

  .ranking-img-title {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
  }

  .ranking-img-title span {
    margin: 0 15px;
    display: block;
    font-size: 14px;
  }

  .hot-tag {
    background: url("../assets/homepage/hot.png") no-repeat;
    width: 31px;
    height: 57px;
    position: absolute;
    top: 0;
    left: 10px;
    font-size: 16px;
    color: #fff;
    padding-top: 5px;
  }

  .ranking-list {
    margin-top: 10px;
    padding: 0 15px;

  }

  .ranking-list li {
    display: block;
    line-height: 28px;
    font-size: 14px;
    overflow: hidden;
    height: 28px;
    text-align: justify;
    color: #000;
  }

  .ranking-list li:hover {
    text-decoration: underline;
    color: #379ce9;
    cursor: pointer;
  }

  .ff0000 {
    color: #ff0000;
  }

  .ff5a00 {
    color: #ff5a00;
  }

  .ff7e00 {
    color: #ff7e00;
  }

  .recommend-bg {
    border: #ddd 1px solid;
    margin-bottom: 10px;
  }

   /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  .active-title, .recommend-title {
    font-size: 20px;
    color: #000;
    text-align: left;
    padding: 5px 0;
    margin: 10px 10px;
    border-bottom: #ddd 1px solid;
  }

  /*本站推荐*/
  .recommend-title span {
    color: #379ce9;
  }

  .recommend-list {
    font-size: 14px;
    text-align: justify;
  }

  .recommend-list li a {
    display: block;
    line-height: 35px;
    position: relative;
    padding: 0 10px 0 20px;
    overflow: hidden;
    height: 35px;
    text-align: left;
    text-decoration: none;
    color: #2c3e50;
  }

  .recommend-list li a:before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #379ce9;
    position: absolute;
    left: 10px;
    top: 15px;
  }

  .recommend-list li a:hover {
    text-decoration: underline;
    color: #379ce9;
  }

  @media screen and (max-width: 1024px) {
    .main {
      width: 100%;
    }
    .tutorial-list-bg {width: 100%;}

  }

</style>



// WEBPACK FOOTER //
// src/components/tutorial.vue